export default "__VITE_ASSET__ByI7VqmY__"